// extracted by mini-css-extract-plugin
module.exports = {"infoBarContainer":"InfoBox_infoBarContainer__zBdrn","iconContainer":"InfoBox_iconContainer__30feV","textContainer":"InfoBox_textContainer__3KydT"};